<template>
  <div class="postback-fields">
    <SettingsField :label="$t('platform.postback')" :hint="$t('platform.card.fields.postback_url')" :tooltip="$t('platform.postback_pop_up')">
      <TraffbackWithMacros class="p-0 mt-0" v-model="form.postback_url" :macroses="macroses" :invalid="invalid" :title="'postback_url'" @addMacros="addMacros" />
    </SettingsField>

    <SettingsField v-if="templates.length" :label="$t('platforms.ready_templates')" :hint="$t('platform.card.fields.postback_templates')">
      <custom-multiselect :value="template" :list="templates" class="templates" :allowEmpty="true" :searchBy="'name'" @input="applyTemplate">
        <template v-slot:block="props">
          <span v-if="props.value">{{ props.value.name }}</span>
          <span v-else>{{ $formatLabel("select_template") }}</span>
        </template>
        <template v-slot:list="props">
          <span>{{ props.value.name }}</span>
        </template>
      </custom-multiselect>
    </SettingsField>

    <SettingsField :label="$t('platform.send_postback_to')" :hint="$t('platform.card.fields.postback_formats')">
      <custom-multiselect :list="formatList" v-model="form.postback_format" :allowEmpty="true" :multiply="true">
        <template v-slot:block="props">
          <span>{{ props.value.title }}</span>
        </template>
        <template v-slot:list="props">
          <span>{{ props.value.title }}</span>
        </template>
      </custom-multiselect>
    </SettingsField>
  </div>
</template>
<script>
import SettingsField from "@/components/PlatformCard/SettingsField.vue";
import TraffbackWithMacros from "@/components/TraffbackWithMacros.vue";
import addMacros from "@/mixins/addMacros";

// Where conversions are reported. Edits `form` in place: postback_url and postback_format.
export default {
  name: "PostbackFields",
  components: { SettingsField, TraffbackWithMacros },
  mixins: [addMacros],
  props: {
    form: {
      type: Object,
      required: true,
    },
    formatList: {
      type: Array,
      required: true,
    },
    // Ready-made postback URLs of trackers; arbitrage platforms only
    templates: {
      type: Array,
      default: () => [],
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { template: null };
  },
  computed: {
    // addMacros edits `platform[title]`
    platform() {
      return this.form;
    },
  },
  methods: {
    applyTemplate(template) {
      this.template = template;
      this.form.postback_url = template ? template.postback_url : "";
    },
  },
};
</script>
